import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from '../components/App'
import configureStore from "../store";
import ErrorBoundary from "./partials/util/ErrorBoundary";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { IconContext } from "react-icons";
import * as Sentry from "@sentry/react";
import config from "../util/config";
import utils from "../util/util";
import log from "../util/log";

const store = configureStore()

const getDynamicBasename = () => {
  let basename = utils.isHandleUrl(window.location.pathname) ?
    '/' + window.location.pathname.split('/')[1] :
    `/${config.appBasename}`;

  // log.log('getDynamicBasename', basename);
  return basename;
}

class Root extends Component {
  componentDidMount() {
    //force the app to run within the configured basename, or handle if within debug.
    if(config.debug){
      let pathname = window.location.pathname;
      if(!utils.isHandleUrl(pathname) && pathname.indexOf(`/${config.appBasename}`) === -1){
        log.warn('Unsupported url,redirecting to', `${window.location.origin}/${config.appBasename}`);
        window.location.href = `${window.location.origin}/${config.appBasename}`;
      }
    }
  }

  render() {
    return (
      <DndProvider backend={HTML5Backend}>
        <IconContext.Provider value={{ className: "react-icons-icon" }}>
          <Provider store={store}>
            <BrowserRouter basename={getDynamicBasename()}>
              <Sentry.ErrorBoundary>
                <ErrorBoundary>
                  <App/>
                </ErrorBoundary>
              </Sentry.ErrorBoundary>
            </BrowserRouter>
          </Provider>
        </IconContext.Provider>
      </DndProvider>
    )
  }
}

export default Root;
